import { render } from "./SearchBox.vue.js?vue&type=template&id=bad04da8!=!../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./SearchBox.vue?vue&type=template&id=bad04da8"
import script from "./SearchBox.vue.js?vue&type=script&lang=js!=!../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./SearchBox.vue?vue&type=script&lang=js"
export * from "./SearchBox.vue.js?vue&type=script&lang=js!=!../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./SearchBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__